module.exports = __webpack_public_path__ + "img/australia-transport-accidents-male.ab9da9f0.png";